module.exports = __webpack_public_path__ + "static/media/IGS-navy-faces.f964e620.png";